<template>
  <div class="mz-find-difference">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        left: setValue(startGameConfig.mainImage.pos.x, 0) + 'px',
        top: setValue(startGameConfig.mainImage.pos.y, 0) + 'px',
        width: setValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setValue(startGameConfig.mainImage.height, 1080) + 'px',
      }"
    />
    <mb-audio-in-game
      :key="data.top + data.left + 'audio' + index"
      :style="{ ...data.cssStyle }"
      v-for="(data, index) in startGameConfig.mbStaticAudioItemData"
      :item-data="data"
      :id="data.id"
    ></mb-audio-in-game>
    <div :key="'mz-find-difference-item-' + index" v-for="(data, index) in items">
      <img
        draggable="false"
        :key="'mz-find-difference-item-image-' + data.id"
        @click="clickOnMe(data)"
        :style="{
          left: setValue(data.show.pos.x, 0) + 'px',
          top: setValue(data.show.pos.y, 0) + 'px',
          width: setValue(data.show.width, 100) + 'px',
          height: setValue(data.show.height, 100) + 'px',
        }"
        :src="giveMeImagePlease(data.show.src)"
        class="mz-find-difference-item-image"
      />
    </div>
    <progress-bar
      v-if="startGameConfig.progressBar"
      :style="startGameConfig.progressBar.cssStyle"
      :src="giveMeProgressImagePlease()"
    ></progress-bar>
  </div>
</template>
<script>
import { Howler } from 'howler';
import _ from 'lodash';
import defaultMixin from '../../mixins/defaultMixin';
import mbAudioInGame from '__mainSrcDir/components/MbAudioModal/MbAudioInGame';
import ProgressBar from './ProgressBar';
export default {
  name: 'mz-listen-and-point',
  mixins: [defaultMixin],
  components: { mbAudioInGame, ProgressBar },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      progress: 0,
      items: [],
      canIPlayASong: true,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let index = 0;
      this.progress = 0;
      this.items = [];
      for (let item of this.startGameConfig.items) {
        item.freeLikeAWind = true;
        item.show = item.image;
        item.audioStatus = false;
        item.audio = this.audioCreate(item.audioSrc, index);
        this.items.push(item);
        index++;
      }
    },
    setValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    giveMeProgressImagePlease() {
      const path = this.startGameConfig.progressBar.image[this.progress];
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    audioCreate(src, index) {
      return new Howl({
        src: this.giveMeImagePlease(src),
        autoplay: false,
        loop: false,
        volume: 0.5,
        onend: () => {
          this.canIPlayASong = true;
          this.aduioStatus(index, false);
        },
        onstop: () => {
          this.canIPlayASong = true;
          this.aduioStatus(index, false);
        },
        onplay: () => {
          this.canIPlayASong = false;
          this.aduioStatus(index, true);
        },
      });
    },
    aduioStatus(index, value) {
      let it = this.items[index];
      it.audioStatus = value;
      this.$set(this.items, index, it);
    },
    playFieldAudio(audio) {
      if (audio && this.canIPlayASong) {
        audio.play();
      } else if (audio) {
        audio.stop();
      }
    },
    clickOnMe(d) {
      if (d.freeLikeAWind) {
        if (typeof d.different !== 'undefined' && d.different == false) {
          this.items.forEach((el, ind, arr) => {
            if (el.id == d.id || el.id == d.linkedId) {
              const prev = el.show;
              el.show = el.mask;
              setTimeout(() => {
                el.show = prev;
              }, (el.audio ? el.audio.duration() : 0.648) * 1000 + 100);
            }
            if (el.id == d.id && el.audio) {
              // arr.forEach((el) => {
              //   el.audio.stop();
              // });
              this.canIPlayASong = true;
              this.playFieldAudio(el.audio);
            }
          });
        } else {
          this.progress++;
          let count = 0;
          this.items.forEach((el, ind, arr) => {
            if (el.id == d.id || el.id == d.linkedId) {
              el.freeLikeAWind = false;
              el.show = el.mask;
              arr[ind] = el;
            }
            if (el.id == d.id && el.audio) {
              // arr.forEach((el) => {
              //   el.audio.stop();
              // });
              this.canIPlayASong = true;
              this.playFieldAudio(el.audio);
            }
            if (!el.freeLikeAWind) count++;
          });
          if (count == 2 * this.startGameConfig.pick) this.$store.dispatch('checkGame');
        }
      }
    },
    resetGameAction() {
      this.init();
    },
    checkGameAction() {
      return true;
    },
  },
};
</script>
<style lang="sass" scoped>
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 900px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mz-find-difference-item-image
  position: absolute
</style>
